import { Container } from "../../components/layout/Container.jsx";
import { PageHero } from "../../components/shared/PageHero.jsx";
import { RichText } from "../../components/shared/RichText.jsx";
import { SEO } from "../../lib/seo.jsx";

/**
 * Generic legal page — renders one of the three legal copies passed in via
 * the `demoHtml` prop. Wrapper pages (PrivacyPolicyPage, TermsPage,
 * DueDiligencePage) supply the static HTML; legal copy is no longer
 * editable from the admin panel.
 */
export function LegalPage({ title, description, eyebrow, demoHtml }) {
  const html = demoHtml;

  return (
    <>
      <SEO title={title} description={description} />

      <PageHero eyebrow={eyebrow ?? "Legal"} title={title} description={description} />

      <Container className="py-16 lg:py-20">
        <div className="mx-auto max-w-3xl">
          {html ? (
            <>
              <p className="mb-8 text-xs uppercase tracking-[0.25em] text-text-muted">
                Last updated · {new Date().toLocaleDateString("en-AU", {
                  day: "numeric",
                  month: "long",
                  year: "numeric",
                })}
              </p>
              <RichText html={html} />
            </>
          ) : (
            <p className="rounded-2xl border border-dashed border-border-subtle bg-bg-elevated px-6 py-16 text-center text-text-secondary">
              This document is being prepared. Please check back soon.
            </p>
          )}
        </div>
      </Container>
    </>
  );
}
